import React from 'react'
import { TriangleAlert } from 'lucide-react'
import { Badge } from '@/components/ui/badge'

class LocalTime extends React.Component {

  render() {
    const local_time = this.props.local_time

    if (local_time) {
      if (local_time.warnings) {
        return (
          <Badge variant="secondary" size="md" style={this.props.style} title={`Time Zone: ${local_time.time_zone}. ${local_time.warnings}`}>
            <TriangleAlert /> Local time: {local_time.value}
          </Badge>
        )
      }
      else {
        return (
          <Badge variant="secondary" size="md" style={this.props.style} title={`Time Zone: ${local_time.time_zone}`}>
            Local time: {local_time.value}
          </Badge>
        )
      }
    }

    return null
  }
}

export default LocalTime
